import { AgGridReact } from "ag-grid-react";
import { formatDate } from "common";
import dayjs from "dayjs";
import React from "react";
import { Experience, Timeslot } from "types";
import { DashboardSummaryHeader } from "../DashboardSummaryHeader";
import { DateNavigationDirection, useDashboardFilterStore } from "@/stores/dashboardFilterStore";

interface TableHeaderProps {
    timeslots: Timeslot[];
    experiences: Experience[];
    tableRef?: React.RefObject<AgGridReact>;
}

export const TableHeader = ({ timeslots, experiences, tableRef }: TableHeaderProps) => {
    const currentDate = useDashboardFilterStore((state) => formatDate(state.date));

    const handleDateChange = (date: Date) => {
        useDashboardFilterStore.getState().setDate(dayjs(date));
    };

    const handleCustomButtonClick = (direction: DateNavigationDirection) => {
        useDashboardFilterStore.getState().changeDate(direction);
    };

    return (
        <DashboardSummaryHeader
            date={currentDate}
            timeslots={timeslots}
            isCollapsed={false}
            tableGridRef={tableRef}
            visibleExperiences={experiences}
            handleCustomButtonClick={handleCustomButtonClick}
            onChange={handleDateChange}
        />
    );
};
